import contract from '@mailobj-browser/front/js/contracts/contract.js'
import space from './space/space.js'

export default contract({
  space
})
